import React from "react";
import { Navigate } from "react-router-dom";

function AdminPassword() {
  return <Navigate to="/adminPage/account" replace />;
}

export default AdminPassword;
